module.exports = __webpack_public_path__ + "static/media/hpbd.04c5ccf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hpbd.mp3
// module id = Z+oK
// module chunks = 1